import { render, staticRenderFns } from "./app-drawer-table.vue?vue&type=template&id=3fda1c62&scoped=true&"
import script from "./app-drawer-table.vue?vue&type=script&lang=js&"
export * from "./app-drawer-table.vue?vue&type=script&lang=js&"
import style0 from "./app-drawer-table.vue?vue&type=style&index=0&id=3fda1c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda1c62",
  null
  
)

export default component.exports